import { Icon as IconifyIcon } from '@iconify/react';
import { styled } from '@linaria/react';

interface SlashCommandTagProps {
  name: string;
}

export function SlashCommandTag({ name }: SlashCommandTagProps) {
  return (
    <Tag>
      <IconifyIcon icon="material-symbols:terminal" width={13} height={13} />/{name}
    </Tag>
  );
}

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  vertical-align: baseline;
  white-space: nowrap;
  background: var(--sky-light);
  color: inherit;
`;
